// Arithmetic the model should not guess: + - * / % ^ and parentheses. A small parser, never eval
export const calculatorTool: PlaybookTool = {
  name: "calculate",
  description: "Evaluates an arithmetic expression exactly. Use it for any calculation instead of doing it yourself.",
  parameters: { type: "object", properties: { expression: { type: "string", description: "e.g. (3 + 4) * 2 / 7" } }, required: ["expression"] },
  run: async ({ expression }) => {
    try { return String(evaluate(String(expression))) }
    catch (e: any) { return `Could not evaluate: ${e?.message || e}` }
  },
}

function evaluate(text: string): number {
  const tokens = text.match(/\d+(\.\d+)?|[-+*/%^()]/g) || []
  if (tokens.join("") !== text.replace(/\s+/g, "")) throw new Error("only numbers, + - * / % ^ and parentheses")
  let i = 0

  const peek = () => tokens[i]
  const next = () => tokens[i++]

  function primary(): number {
    const t = next()
    if (t === "-") return -primary()
    if (t === "+") return primary()
    if (t === "(") {
      const value = sum()
      if (next() !== ")") throw new Error("missing )")
      return value
    }
    if (t === undefined || Number.isNaN(Number(t))) throw new Error(`unexpected ${t ?? "end"}`)
    return Number(t)
  }

  function power(): number {
    const base = primary()
    return peek() === "^" ? (next(), base ** power()) : base
  }

  function product(): number {
    let value = power()
    while (peek() === "*" || peek() === "/" || peek() === "%") {
      const op = next()
      const right = power()
      value = op === "*" ? value * right : op === "/" ? value / right : value % right
    }
    return value
  }

  function sum(): number {
    let value = product()
    while (peek() === "+" || peek() === "-") value = next() === "+" ? value + product() : value - product()
    return value
  }

  const result = sum()
  if (i < tokens.length) throw new Error(`unexpected ${tokens[i]}`)
  return result
}
